import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	insertTitle: {
		id: 'fabric.editor.agentManagedExtension.insert.title',
		defaultMessage: 'Agent-managed block',
		description:
			'Quick insert / block menu title for inserting a Confluence block whose body is managed by a Rovo agent.',
	},
	insertDescription: {
		id: 'fabric.editor.agentManagedExtension.insert.description',
		defaultMessage: 'Configure a block to your desired output and let Rovo keep it updated',
		description: 'Quick insert / block menu description for inserting an agent-managed block.',
	},
	customize: {
		id: 'fabric.editor.agentManagedExtension.toolbar.customize',
		defaultMessage: 'Customize',
		description:
			'Floating toolbar button label that opens the inline configuration for an agent-managed block.',
	},
	configureBlock: {
		id: 'fabric.editor.agentManagedExtension.config.title',
		defaultMessage: 'Customize Agent-managed block',
		description: 'Heading of the inline configuration panel for an agent-managed block.',
	},
	customInstructionsLabel: {
		id: 'fabric.editor.agentManagedExtension.config.customInstructionsLabel',
		defaultMessage: 'Custom instructions',
		description:
			'Label for the textarea where the user enters the agent prompt for an agent-managed block.',
	},
	customInstructionsPlaceholder: {
		id: 'fabric.editor.agentManagedExtension.config.customInstructionsPlaceholder',
		defaultMessage:
			'Tell the agent what this block should contain. For example: "Summarise the latest takeaways from my meetings with Team A and write a short summary that..."',
		description: 'Placeholder text for the agent prompt textarea.',
	},
	save: {
		id: 'fabric.editor.agentManagedExtension.config.save',
		defaultMessage: 'Save',
		description: 'Save button in the inline configuration panel for an agent-managed block.',
	},
	cancel: {
		id: 'fabric.editor.agentManagedExtension.config.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button in the inline configuration panel for an agent-managed block.',
	},
	blockLabel: {
		id: 'fabric.editor.agentManagedExtension.blockLabel',
		defaultMessage: 'Agent-managed',
		description: 'Small lozenge label shown on the agent-managed block in the editor.',
	},
});
